import { render } from "./NavbarLogoutButton.vue?vue&type=template&id=1a49fe4e&scoped=true"
import script from "./NavbarLogoutButton.vue?vue&type=script&lang=js"
export * from "./NavbarLogoutButton.vue?vue&type=script&lang=js"

import "./NavbarLogoutButton.vue?vue&type=style&index=0&id=1a49fe4e&scoped=true&lang=css"

import exportComponent from "/builds/Xpansiv/evo/DataPipeline/DataPipeline.Evolve.Web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a49fe4e"]])

export default __exports__